module.exports = __webpack_public_path__ + "media/Loops 110 Vocals.742a3351.wav";